// extracted by mini-css-extract-plugin
export default {"invalid":"Invalid_invalid__NenKE","invalid__icon":"Invalid_invalid__icon__YTNCK"};